import React, { PureComponent } from 'react';
import PropTypes, {any} from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

// import SearchField from '@components/core/TextFields/SearchField';
// import Typography from '@components/core/Typography';
// import DeletableTag from '@components/core/Buttons/DeletableTag';

import TableTop from './TableTop';
import TableHeader from './TableHeader';
import TableCellMenu from './TableCellMenu';
import { CSVLink, CSVDownload } from "react-csv";

class CustomTable extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      order: 'asc',
      orderBy: '',
      data: [],
      csv: [],
      anchorEl: null,
      searchValue: ''
    };
  }

  componentDidMount() {
    this.composeData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const {
      data,
      csv,
      searchFields,
      searchFieldFilter,
      checkboxFilters,
      secondaryCheckboxFilters,
      tagsFilter,
      lastUpdateFilter,
    } = this.props;

    // const areFiltersChanged = nextProps.searchFields !== searchFields
    //   || nextProps.searchFieldFilter.value !== searchFieldFilter.value
    //   || nextProps.checkboxFilters !== checkboxFilters
    //   || nextProps.secondaryCheckboxFilters !== secondaryCheckboxFilters
    //   || nextProps.tagsFilter !== tagsFilter
    //   || nextProps.lastUpdateFilter.value !== lastUpdateFilter.value;

    const areFiltersChanged = nextProps.searchFieldFilter.value !== searchFieldFilter.value;

    // It is only needed to compose the data if the next data or the next filters ara changed.
    if (nextProps.data !== data || areFiltersChanged) {
      this.composeData(nextProps);
    }
  }

  setFinalData = (data, csv) => {
    const { searchFields } = this.props;
    // console.log("setFinalData with " + JSON.stringify(this.props));
    const hasSearch = searchFields && searchFields.length > 0;
    const finalData = !hasSearch ? data : this.applySearch(data, searchFields);

    // Remove any "is_total" row
    const total = finalData.findIndex(row => row.hasOwnProperty("is_total"));
    // console.log("Total index: " + total);
    if (total !== -1) finalData.splice(total, 1);

    const totals = {};

    if (csv) {
      const headers = [];
      Object.keys(this.props.columns).map(x => {
        headers.push(this.props.columns[x].key);
      });
      csv.push(headers);
    }

    // Add totals and csv here
    finalData.map((row, index) => {
      const csv_row = [];

      Object.keys(this.props.columns).map(x => {
        const column = this.props.columns[x];
        const key = this.props.columns[x].key;
        const col = row[key];
        csv_row.push(col);
        if (column && column.options && column.options.agg) {
          const num = parseFloat(col);
          if (!isNaN(num)) {
            if (!totals.hasOwnProperty(key)) totals[key] = 0;
            totals[key] += num;
          }
        }
      });
      if (csv) csv.push(csv_row);
    });

    // finalData.map((row, index) => {
    //   const csv_row = [];
    //   Object.keys(row).map((col) => {
    //     const column = this.props.columns.find(c => c.key === col);
    //     csv_row.push(row[col]);
    //     if (column && column.options && column.options.agg) {
    //       const num = parseFloat(row[col]);
    //       if (!isNaN(num)) {
    //         if (!totals.hasOwnProperty(col)) totals[col] = 0;
    //         totals[col] += num;
    //       }
    //     }
    //   });
    //   if (csv) csv.push(csv_row);
    // });

    // Add an extra row with the totals
    if (finalData.length > 0) {
      const extra_row = {};
      let any_agg = false;
      Object.keys(finalData[0]).map(x => {
        const column = this.props.columns.find(c => c.key === x);
        if (column && column.options && column.options.hasOwnProperty("footer")) {
          extra_row[x] = column.options.footer;
          any_agg = true;
        }
        else if (column && column.options && column.options.hasOwnProperty("agg")) {
          extra_row[x] = totals[x];
          any_agg = true;
        }
        else {
          extra_row[x] = "";
        }
        // if (column && column.options && column.options.hasOwnProperty("formula")) {
        //   extra_row[x] = column.options.formula(extra_row);
        //   any_agg = true;
        // }
      });

      if (any_agg) {
        extra_row.is_total = true;
        console.log(extra_row);
        finalData.push(extra_row);
      }
    }

    return finalData;
  };

  filterListByStringKeys = (list, filterKeys = [], filterString = '') => {

    try {

      // Try to make this code more readable...

      // If invalid data to filter, return the list
      if (filterKeys === null || filterKeys.length === 0 || list === null || typeof filterKeys === 'string') return list;

      const filter_words = filterString.split(",");

      return list.filter(listItem => {
        // Foreach row

        let all_found = true;

        // If any filter fails, skip the row. Only when all filters appear in at least one key, the row will be returned
        // Check of columns, see if the filtered word is present in at least one
        filter_words.map(word => {
          const found = Object.keys(listItem).some(id => filterKeys.includes(id) && typeof listItem[id] === 'string' && listItem[id].toLowerCase().includes(word.toLowerCase()));
          if (!found) all_found = false;
        });

        return all_found;
      });


      // const filteredList = (filterKeys && filterKeys.length > 0 && list && typeof filterKeys !== 'string')
      //   ? list.filter(listItem => filterKeys.some(key => {
      //
      //       // If the filter does not exist in the data, just ignore the filter
      //       if (!listItem.hasOwnProperty(key)) return false;
      //
      //       // Try to filter by words separated by commas
      //
      //       if (listItem[key] === null) return false;
      //
      //       return filterString.split(",").some(x => listItem[key].toLowerCase().includes(x.toLowerCase()));
      //
      //       // return listItem.hasOwnProperty(key) && listItem[key] !== null && listItem[key].toLowerCase().includes(filterString.toLowerCase())
      //     }
      //   ))
      //   : list;
      // return filteredList;
    }
    catch(e) {
      console.error(e);
      return list;
    }

  };

  applyFilters = (data, props) => {
    const {
      searchFields,
      searchFieldFilter,
    } = props;
    const {
      value: searchFieldValue,
      keys: searchFieldKey,
    } = searchFieldFilter;

    // Filter by key string using search field value.
    const hasCustomSearchField = searchFields && searchFields.length > 0;
    const sortedData = !hasCustomSearchField
      ? this.filterListByStringKeys(data, searchFieldKey, searchFieldValue)
      : data;

    return sortedData;
  };

  composeData(props) {
    const { data: rows, columns } = props;
    const csv = [];
    const data = [];
    rows && rows.map((row) => {
      let element = row;
      columns && columns.map((column) => {
        if (column.value) {
          //console.log(column.value(row));
          element[column.key] = column.value(row);
        }
      });
      data.push(element);   
    });

    const filteredData = this.applyFilters(data, props);

    const finalData = this.setFinalData(filteredData, csv);
    this.setState({ data: finalData, csv: csv });
  }

  handleRequestSort = (event, property) => {

    const { order, orderBy, data, csv } = this.state;
    let sortOrder = 'desc';
    if (orderBy === property && order === 'desc') {
      sortOrder = 'asc';
    }
    const sortedData = sortOrder === 'desc'
      ? data.sort((a, b) => (b[property] < a[property] ? - 1 : 1))
      : data.sort((a, b) => (a[property] < b[property] ? - 1 : 1));

    console.log(data);
    console.log(sortedData);

    const finalData = this.setFinalData(sortedData, csv);
    this.setState({ data: finalData, order: sortOrder, orderBy: property });
  };

  handleClick = (column, columnIdx, row, rowIdx) => {
    if (this.props.onClick) this.props.onClick(column, columnIdx, row, rowIdx);
  };


  renderCell(column, columnIdx, row, rowIdx) {
    const { classes } = this.props;
    const value = row[column.key];

    if (column.options && column.options.header) columnIdx = column.options.header;

    if (column.options && column.options.hide === true) return null;

    return (
      <TableCell
        key={`row-${rowIdx}-col-${columnIdx}`}
        onClick={() => column.onClick ? column.onClick(row) : {}}
        align={column.numeric ? 'right' : column.options.align || 'inherit'}
        className={classes.cell}
        style={{
          whiteSpace: "nowrap",
          width: "auto",
          paddingRight: '8px', 
          paddingTop: '2px',
          paddingBottom: '2px',
          ...column.style, // Allow custom styles per column
        }}
      >
        {
          column.render
            ? column.render(row, rowIdx)
            : value
        }
      </TableCell>
    );
  }

  renderRow(row, rowIdx) {
    const { classes, columns, hideOptions, tagsFilter } = this.props;

    return (
      <React.Fragment key={`row-${rowIdx}`}>
        <TableRow className={classes.row}>
          {columns.map((column, index) => this.renderCell(column, index, row, rowIdx))}
          {!hideOptions && <TableCellMenu onEdit={() => this.props.onEdit(row)} onDelete={() => this.props.onDelete(row)} />}
        </TableRow>
      </React.Fragment>
    );
  }

  renderHeader() {
    const { headers = true, hideOptions } = this.props;
    const { data, order, orderBy } = this.state;
    if (headers && data) {
      return (
        <TableHeader 
          columns={this.props.columns} 
          order={order}
          orderBy={orderBy}
          onRequestSort={this.handleRequestSort}
          rowCount={data.length}
          hideOptions={hideOptions}
        />
      );
    }
  }

  applySearch = (data, searchFields) => {
    console.log("Applying search using " + JSON.stringify(searchFields));
    const { searchValue } = this.state;
    const filteredData = data.filter(dataRow => {
      let someFieldContains = false;
      for (let i = 0; i < searchFields.length; i++) {
        if (dataRow[searchFields[i]].toLowerCase().includes(searchValue.toLowerCase())) {
          someFieldContains = true;
          break;
        }
      }
      return someFieldContains;
    });
    return filteredData;
  };

  onChangeSearch = (name, value) => this.setState({ [name]: value });

  // onSearchBlur = () => {
  //   if (this.state.searchValue)
  //     trackSearch();
  // };

  render() {
    const {
      classes,
      hideTop,
      hideHeader,
      hidePadding,
      searchFields,
      hideCsv
    } = this.props;
    const {
      data,
      searchValue,
    } = this.state;
    if (!data) return null;
    const hasSearch = searchFields && searchFields.length > 0;
    const tablePadding = hidePadding ? undefined : classes.tablePadding;

    return (
      <div>
        {/*{ hasSearch*/}
        {/*  ? <SearchField*/}
        {/*    // onBlur={this.onSearchBlur}*/}
        {/*    onChange={this.onChangeSearch}*/}
        {/*    value={searchValue}*/}
        {/*    name="searchValue"*/}
        {/*  />*/}
        {/*  : null*/}
        {/*}*/}
        <div className={classes.root}>
          {!hideTop && <TableTop>{this.props.title}</TableTop>}
          {
            !hideCsv && this.state.csv && <CSVLink data={this.state.csv}>Download CSV</CSVLink>
          }
          <Table className={classNames(classes.table, tablePadding)}>
            {!hideHeader && this.renderHeader()}
            <TableBody>
              {
                data.map((row, index) => {
                  return(this.renderRow(row, index));
                })
              }
            </TableBody>
          </Table>
        </div>
      </div>
    );
  }  
}

CustomTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  csv: PropTypes.array,
  hideTop: PropTypes.bool,
  hideHeader: PropTypes.bool,
  hidePadding: PropTypes.bool,
  hideOptions: PropTypes.bool,
  hideCsv: PropTypes.bool,
  headers: PropTypes.bool,
  onClick: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  searchFieldFilter: PropTypes.shape({
    value: PropTypes.string,
    keys: PropTypes.arrayOf(PropTypes.string),
  }),
  lastUpdateFilter: PropTypes.shape({
    value: PropTypes.instanceOf(Date),
    key: PropTypes.string,
  }),
};

CustomTable.defaultProps = {
  searchFieldFilter: { value: '', key: 'name' },
  lastUpdateFilter: { value: new Date(), key: 'updatedAt' },
  onClick: () => {},
  onEdit: () => {},
  onDelete: () => {},
};

const styles = {
  root: {
    // backgroundColor: 'white',
    borderRadius: '8px',
  },
  table: {
    overflow: 'hidden',
    // tableLayout: 'fixed',
    borderCollapse: 'collapse',
    width: "100%",
    tableLayout: "auto",
  },
  tablePadding: {
    padding: '4px 4px',
  },
  row: { 
    padding: 0,
  },
  cell: {
    padding: 0,
    height: 20,
    marginTop: 2,
    marginBottom: 2,
  },
  rowHeader: {
    textAlign: 'left',
    verticalAlign: 'bottom',
    fontWeight: 400,
    height: 'auto',
  },
  rowHeaderContent: {
    display: 'flex',
    // width: '100%',
    padding: 0,
    paddingTop: 16,
    border: 'none',
  },
  deletableTagWithoutIcon: {
    marginRight: 0,
  },
};

export default withStyles(styles)(CustomTable);
